<template>
  <div class="time">
    <div class="timeBox" :class="{'on':show}" @click="show=true">{{showTime}}</div>
    <!-- 时间弹框 -->
    <van-popup v-model="show" round position="bottom">
      <van-datetime-picker v-model="currentDate" @confirm="sureTime" @cancel="cancelTime" cancel-button-text="清空" type="datetime" title="选择时间" :formatter="formatter" />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      currentDate: new Date(),
      showTime: this.value === '' ? '选择日期' : this.value
    };
  },
  watch: {
    value(n, o) {
      if (n === '') {
        this.showTime = '选择日期';
      }
    }
  },
  methods: {
    // 转字符串时间
    getDateTime(val) {
      var year = val.getFullYear();
      var month = val.getMonth() + 1;
      var day = val.getDate();
      var h = val.getHours();
      var m = val.getMinutes();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      if (h < 10) {
        h = '0' + h;
      }
      if (m < 10) {
        m = '0' + m;
      }
      return year + '-' + month + '-' + day + ' ' + h + ':' + m;
      // return year + '-' + month + '-' + day;
    },
    // 选择时间过滤
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'hour') {
        return `${val}时`;
      } else if (type === 'minute') {
        return `${val}分`;
      }
      return val;
    },
    // 确认时间
    sureTime(val) {
      this.showTime = this.getDateTime(val);
      this.$emit('update:value', this.showTime);
      this.show = false;
    },
    // 取消时间选择
    cancelTime() {
      this.showTime = '选择日期';
      this.currentDate = new Date();
      this.$emit('update:value', '');
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.time {
  .timeBox {
    height: 30px;
    padding-left: 36px;
    background: #fff url(../assets/images/clock.png) no-repeat 6px center;
    background-size: auto 20px;
    border-radius: 4px;
    line-height: 32px;
    color: #b1b1b1;
    font-size: 15px;
    text-align: left;
    border: 1px solid #dbd8d8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.on {
      border-color: #1abc9c;
    }
  }
}
</style>
